import { Button, Group, Select, Stack, Textarea, TextInput } from '@mantine/core';
import { useForm } from '@mantine/form';
import { closeAllModals } from '@mantine/modals';
import { FC, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { FAQsProperty, FAQsPropertyItem } from '@mygpt/app';

export interface FaqsPropertyItemEditProps {
  propetry?: FAQsPropertyItem;

  onSubmit?: (propetry: FAQsProperty) => Promise<void>;
}

export const FaqsPropertyItemEdit: FC<FaqsPropertyItemEditProps> = ({ onSubmit, propetry }) => {
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);
  const form = useForm({
    initialValues: {
      title: propetry?.title ?? '',
      type: ['text', 'multiple'].indexOf(propetry?.type ?? '') > -1 ? propetry?.type ?? '' : 'text',
      description: propetry?.description ?? '',
    },
    validate: {
      title: (value) => {
        return value ? null : t('fields.title_invalid');
      },
      type: (value) => {
        return value ? null : t('fields.type_invalid');
      },
      description: (value) => {
        return value ? null : t('fields.description_invalid');
      },
    },
  });

  const handleSubmit = async (values: typeof form.values) => {
    setLoading(true);
    await onSubmit?.(values);
    setLoading(false);
  };

  return (
    <form onSubmit={form.onSubmit(handleSubmit)}>
      <Stack gap="xs">
        <TextInput
          withAsterisk
          label={t('faqs.property.form.title')}
          placeholder={t('faqs.property.form.title_placeholder')}
          {...form.getInputProps('title')}
        />
        <Select
          label={t('faqs.property.form.type')}
          placeholder={t('faqs.property.form.type_placeholder')}
          defaultValue="text"
          data={[
            { value: 'text', label: t('faqs.property.form.type_option.text') },
            { value: 'multiple', label: t('faqs.property.form.type_option.multiple') },
          ]}
          {...form.getInputProps('type')}
        />
        <Textarea
          withAsterisk
          label={t('faqs.property.form.description')}
          placeholder={t('faqs.property.form.description_placeholder')}
          minRows={4}
          {...form.getInputProps('description')}
        />
        <div className="flex justify-end">
          <Group>
            <Button variant="outline" onClick={() => closeAllModals()}>
              {t('alert_cancel')}
            </Button>
            <Button type="submit" loading={loading}>
              {t('save')}
            </Button>
          </Group>
        </div>
      </Stack>
    </form>
  );
};
